import BaseApi from "./base_api";
import SimpleApi from "./simple_api";

export default class AccountsApi extends SimpleApi {
  static create(account, { captchaToken } = {}) {
    const accountParams = {
      first_name: account.firstName,
      last_name: account.lastName,
      email: account.email,
      email_confirmation: account.emailConfirmation,
      password: account.password,
      password_confirmation: account.passwordConfirmation,
      date_of_birth: account.dateOfBirth,
      discount_pricing_member: account.discountPricingMember,
      marketing_opt_in: account.marketingOptIn,
      country_code: account.countryCode,
      country_alpha2: account.countryAlpha2,
      phone: account.phoneNumber,
    };

    return this.post(
      "/accounts",
      {
        account: accountParams,
        referral_code: account.referralCode,
      },
      { headers: { "CAPTCHA-TOKEN": captchaToken } },
    );
  }

  static async login(account) {
    const signinParams = {
      email: account.email,
      password: account.password,
      remember_me: account.rememberMe,
    };

    return BaseApi.post("/accounts/sign_in", { account: signinParams });
  }

  static update(account) {
    const accountParams = {
      date_of_birth: account.dateOfBirth,
      discount_pricing_member: account.discountPricingMember,
      marketing_opt_in: account.marketingOptIn,
    };
    return this.patch("/accounts/federated_registration", {
      account: accountParams,
    });
  }
}
